import React from "react"
import moment from 'moment'
import DatePicker from "react-datepicker"


class TripFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filter: this.props.filter,
			// carsForFilter: this.props.carsForFilter,
			isShowFilter: false 
		}
	}


	componentWillReceiveProps(props) {
		this.setState({
			filter: props.filter,
			// carsForFilter: props.carsForFilter
		})
	}

	resetFilter() {
		this.props.resetFilter();
		this.setState({
			isShowFilter: false
		})
	}

	onFilterChange(event) {
		var filter;
	
		filter = {
			...this.props.filter,
			carId: "",
			[event.target.name]: event.target.value
		}
	
		this.props.setFilter(filter);
		this.props.getOrders(filter);
		this.setState({
			isShowFilter: true,
		})
	}

	onFromTimeChange(date) {
		const filter = {
			...this.props.filter,
			fromTime: date.valueOf()
		}
		this.props.setFilter(filter);
		this.props.getOrders(filter);
	}

	onToTimeChange(date) {
		const filter = {
			...this.props.filter,
			toTime: date.valueOf()
		}
		this.props.setFilter(filter);
		this.props.getOrders(filter);
	}


	render() {
		const hasFilter = this.props.checkHasFilter();
		const { viewMode, mode } = this.props;

		// const carsForFilter = this.state.carsForFilter;
		// const stype = this.state.filter.stype;
		const isShowFilter = this.state.isShowFilter;
		
		const status = this.state.filter && this.state.filter.status > 0 ? this.state.filter.status : this.props.defaultFilter.status;
		const sortValue = this.state.filter && this.state.filter.sort > 0 ? this.state.filter.sort : this.props.defaultFilter.sort;
		// const userTypeValue = this.state.filter && this.state.filter.userType > 0 ? this.state.filter.userType : this.props.defaultFilter.userType;
		// const carId = this.state.filter && this.state.filter.carId ? this.state.filter.carId : this.props.defaultFilter.carId;
		// const fromTime = this.state.filter && this.state.filter.fromTime > 0 ? this.state.filter.fromTime : this.props.defaultFilter.fromTime;
		// const toTime = this.state.filter && this.state.filter.toTime > 0 ? this.state.filter.toTime : this.props.defaultFilter.toTime;

		return <div className="content-filter">
			<div className="rent-car" style={{ paddingTop: "0px" }}>

				{/* <span className="slstitle">Chế độ</span>
				<div className="line-radio line-form">
					<label className="custom-radio custom-control">
						<input className="custom-control-input" type="radio" name="stype" value={1} checked={stype === '1'} onChange={this.onFilterChange.bind(this)} /><span className="custom-control-indicator" /><span className="custom-control-description">Tự lái</span>
					</label>
					<label className="custom-radio custom-control">
						<input className="custom-control-input" type="radio" name="stype" value={2} checked={stype === '2'} onChange={this.onFilterChange.bind(this)} /><span className="custom-control-indicator" /><span className="custom-control-description">có tài xế</span>
					</label>
				</div> */}

				{mode == viewMode.UPCOMING && <span className="slstitle">Sắp xếp</span>}
				{mode == viewMode.UPCOMING && <div className="line-form">
					<div className="wrap-select">
						<select name="sort" onChange={this.onFilterChange.bind(this)} value={sortValue}>
							<option value="3">Ưu tiên thay đổi</option>
							<option value="1">Ưu tiên thời gian đặt</option>
							<option value="2">Ưu tiên thời gian khởi hành</option>
						</select>
					</div>
				</div>} 
			 <div>
					{/* <span className="slstitle">Lọc theo</span>
					<div className="line-form">
						<div className="wrap-select">
							<select name="userType" onChange={this.onFilterChange.bind(this)} value={userTypeValue}>
								<option value="0">Tất cả</option>
								<option value="1">Chuyến thuê</option>
								<option value="2">Chuyến cho thuê</option>
							</select>
						</div>
					</div> */}
					<h6 className="slstitle">Trạng thái</h6>
					<div className="line-form">
						<div className="wrap-select form-group">
							{mode == viewMode.UPCOMING ?
								<select name="status" className="form-control" onChange={this.onFilterChange.bind(this)} value={status}>
									<option value="0">Tất cả</option>
									<option value="1">Đang tìm xe</option>
									<option value="2">Đã tìm thấy xe</option>
									<option value="3">Đã đặt cọc</option>
									<option value="4">Đang thuê</option>
									<option value="5">Đã kết thúc</option>
									<option value="6">Không tìm thấy xe</option>
								</select> :
								<select name="status" onChange={this.onFilterChange.bind(this)} value={status}>
									<option value="0">Tất cả</option>
									<option value="1">Đang tìm xe</option>
									<option value="2">Đã tìm thấy xe</option>
									<option value="4">Đang đặt cọc</option>
									<option value="5">Đã hủy</option>
									<option value="6">Đang thuê</option>
									<option value="7">Đã kết thúc</option>
									<option value="9">Không tìm thấy xe</option>
								</select>}
						</div>
					</div>
				</div>
				{/* {isShowFilter && mode == viewMode.HISTORY && <span className="slstitle">Bắt đầu</span>}
				{isShowFilter && mode == viewMode.HISTORY && <div className="line-form">
					{fromTime && fromTime > 0 ?
						<div className="wrap-input datepicker">
							<DatePicker
								selected={moment(fromTime)}
								timeFormat="HH:mm"
								dateFormat="DD/MM/YYYY"

								onChange={this.onFromTimeChange.bind(this)} />
						</div> : <div className="wrap-input datepicker">
							<DatePicker
								timeFormat="HH:mm"
								dateFormat="DD/MM/YYYY"
								placeholderText="Bất kì"
								onChange={this.onFromTimeChange.bind(this)} />
						</div>}
				</div>}
				{isShowFilter && mode === viewMode.HISTORY && <span className="slstitle">Kết thúc</span>}
				{isShowFilter && mode === viewMode.HISTORY && <div className="line-form">
					{toTime && toTime > 0 ?
						<div className="wrap-input datepicker">
							<DatePicker
								selected={moment(toTime)}
								timeFormat="HH:mm"
								dateFormat="DD/MM/YYYY"

								onChange={this.onToTimeChange.bind(this)} />
						</div> : <div className="wrap-input datepicker">
							<DatePicker
								timeFormat="HH:mm"
								dateFormat="DD/MM/YYYY"
								placeholderText="Bất kì"
								onChange={this.onToTimeChange.bind(this)} />
						</div>}
				</div>} */}
			
				<div className="space m"></div>
				<a className={`btn btn-default btn--m btn-reset ${hasFilter ? "has-dot-red" : ""}`} style={{ width: "100%" }} onClick={this.resetFilter.bind(this)}><i className="ic ic-reset"></i> Bỏ lọc</a>
			</div>
		</div>

	}
}
export default TripFilter;


// WEBPACK FOOTER //
// ./src/components/trip/tripfilter.js